import { render, staticRenderFns } from "./SearchWidget.vue?vue&type=template&id=9bca59ca&scoped=true"
import script from "./SearchWidget.vue?vue&type=script&lang=ts"
export * from "./SearchWidget.vue?vue&type=script&lang=ts"
import style0 from "./SearchWidget.vue?vue&type=style&index=0&id=9bca59ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bca59ca",
  null
  
)

export default component.exports